import { supabase } from '@/integrations/supabase/client';

export const sendUserApprovalEmail = async (
  userEmail: string,
  firstName: string,
  lastName: string
): Promise<boolean> => {
  try {
    const { data, error } = await supabase.functions.invoke('send-approval-email', {
      body: {
        email: userEmail,
        firstName,
        lastName
      }
    });

    if (error) {
      console.error('Error sending approval email:', error);
      return false;
    }

    console.log('Approval email sent successfully:', data);
    return true;
  } catch (error) {
    console.error('Failed to send approval email:', error);
    return false;
  }
};

// New function to send password reset emails
export const sendPasswordResetEmail = async (
  userEmail: string
): Promise<boolean> => {
  try {
    const { data, error } = await supabase.functions.invoke('send-password-reset', {
      body: {
        email: userEmail
      }
    });

    if (error) {
      console.error('Error sending password reset email:', error);
      return false;
    }

    console.log('Password reset email sent successfully:', data);
    return true;
  } catch (error) {
    console.error('Failed to send password reset email:', error);
    return false;
  }
};

/** Notifies a system address when someone registers; user still must confirm email. */
export const sendAdminPendingConfirmationNotify = async (params: {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
}): Promise<boolean> => {
  try {
    const { data, error } = await supabase.functions.invoke(
      'notify-admin-registration',
      {
        body: {
          userId: params.userId,
          registerEmail: params.email,
          firstName: params.firstName,
          lastName: params.lastName,
        },
      }
    );

    if (error) {
      console.error('Error calling notify-admin-registration:', error);
      return false;
    }

    console.log('Admin registration notification sent:', data);
    return true;
  } catch (error) {
    console.error('Failed to send admin registration notification:', error);
    return false;
  }
};
